export default __webpack_public_path__ + "static/spa_b.bafa9b4b603ab6d41389af84851bce04.svg";